// SalfaUsados.jsx
import { useEffect, useState } from 'react'
import BaseLayoutStore from 'components/Layout/BaseLayoutStore'
import FormContactStore from 'components/Customs/Contact/FormContactStore'
import ModalSpinner from 'components/Customs/Modal/ModalSpinner'
import ItemResult from 'components/Concessionaire/ItemResult';
import styles from "styles/store.module.css"
import { Link } from "react-router-dom";
import compare_quote from 'assets/images/icon/compare-quote.svg'
import order_store from 'assets/images/order-store.svg'

import { useParams, useLocation } from 'react-router-dom'
import { useConfig } from "hooks/MetaHead/useConfig"
import { useFunctionBaseConcesionaire } from "hooks/Concesionaire/useFunctionBaseConcesionaire";
import axios from 'axios';
import style from "./style.module.css"



const SalfaUsados = () => {
  const location = useLocation()
  const { slug } = useParams()

  const [descriptionMeta, setDescriptionMeta] = useState({})

  const { actions, state } = useFunctionBaseConcesionaire()

  const { detailConcessionare, listCarsAssign, carSelectedQuote, isLoadingSearch, listModels, textModel, menuSort } = state

  const { getDataInitialHome, selectedQuote, handleMoveTo, setTextModel, searchListCarByFilter, updateOrder } = actions

  const { getDataMetaTag } = useConfig()

  const getDataInitial = async (slug) => {
    const infoMeta = await getDataMetaTag(location?.pathname)
    setDescriptionMeta(infoMeta)
    //const store = typeof location?.state?.store !=="undefined" ? location?.state?.store : null
    await getDataInitialHome(slug)
  }

  useEffect(() => {
    getDataInitial('salfa-usados');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  const [autos, setAutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const autosPorPagina = 12;

  useEffect(() => {
    const fetchAutos = async () => {
      try {
        const response = await fetch('https://prod.movicenter.cl/api/v1/stock/portales/sucursal/1447', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ /* datos */ }),
        });

        if (!response.ok) {
          throw new Error('Error al obtener los datos');
        }

        const data = await response.json();
        setAutos(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAutos();
  }, []);

  const indexOfLastAuto = currentPage * autosPorPagina;
  const indexOfFirstAuto = indexOfLastAuto - autosPorPagina;
  const autosActuales = autos.slice(indexOfFirstAuto, indexOfLastAuto);

  const totalPages = Math.ceil(autos.length / autosPorPagina);
  const [carSelectedQuote2, setCarSelectedQuote2] = useState([]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  /*if (loading) return (
   <div style={{
     display: 'flex',
     justifyContent: 'center',
     alignItems: 'center',
     height: '100vh',  // para centrar verticalmente en toda la ventana
     fontSize: '1.5rem',
     fontWeight: 'bold'
   }}>
     Cargando...
   </div>
 );*/

  if (error) return <p>Error: {error}</p>;

  return (
    <BaseLayoutStore
      infoMetaHead={descriptionMeta}
      infoHeader={detailConcessionare}
      classStyle={{ classTitle: "header-separator" }}
      isVisibleIcon={true}
      handleMoveTo={handleMoveTo}
    >
      <div className={style.container}>
        <h1 className={style.resultados}>{autos.length} Resultados </h1>
        <div className={style["card-container"]}>
          {autosActuales.map((auto) => {
            const slugModelo = auto.nombreModelo.toLowerCase().replace(/\s+/g, '-');
            const linkTo = `/concesionario/salfa-usados/${slugModelo}`;

              return (
              <div key={auto.idauto} className={style.card}>
                <Link
                  to={{
                    pathname: linkTo,
                    state: { auto }
                  }}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <h2><strong>{auto.year} {auto.nombreMarca} {auto.nombreModelo}</strong></h2>
                  <img src={auto.fotos[0]} alt={auto.nombreModelo} />
                  <p className='desde'>Desde: {auto.moneda}{new Intl.NumberFormat('es-CL').format(auto.precio)}</p>
                  <p>{auto.transmisionNombre}</p>
                  <p>Kms: {auto.kms}</p>
                </Link>

                <div className="acciones-cotizar">
                  <input
                    type="checkbox"
                    id={`cotizar_${auto.idauto}`}
                    value={auto.idauto}
                    className="cotizar-checkbox"
                    checked={carSelectedQuote2.some((item) => item.idauto === auto.idauto)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCarSelectedQuote2((prev) => [...prev, auto]);
                      } else {
                        setCarSelectedQuote2((prev) =>
                          prev.filter((item) => item.idauto !== auto.idauto)
                        );
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="cotizar"
                    onClick={() => {
                      setCarSelectedQuote2((prev) => {
                        const isSelected = prev.some((item) => item.idauto === auto.idauto);
                        return isSelected
                          ? prev.filter((item) => item.idauto !== auto.idauto)
                          : [...prev, auto];
                      });
                    }}
                    style={{
                      fontSize: '16px',
                      padding: '6px 12px',
                      backgroundColor: 'transparent',
                      color: 'gray',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      transition: 'background 0.3s ease',
                    }}
                  >
                    Cotizar
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className={`${style.pagination} mt-4 mb-4`}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Anterior
          </button>

          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={currentPage === index + 1 ?  style.active : ""}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Siguiente
          </button>
        </div>
      </div>




      <FormContactStore
        isVisibleVIN={false}
        itemService={carSelectedQuote2}
        styleForm={{ main: "service-form-contact" }}
        provider="Salfa Usados" // Aquí tu concesionario fijo
      />

      {/* ---- WIDGET DE COTIZACIÓN MÚLTIPLE ---- */}
      {carSelectedQuote2.length > 0 && (
        <div onClick={(event) => handleMoveTo(event, "form")}>
          <div className={styles["widget-foooter"]}>
            <div className={styles["widget-foooter-buttom"]}>
              <div className="container w-90">
                <button
                  type="button"
                  className="btn btn-primary btn-lg w-100"
                >{`Cotizar (${carSelectedQuote2?.length})`}</button>
              </div>
            </div>
          </div>
          <div>
            <section className={styles["widget-container"]}>
              <div className={styles["widget-container-text"]}>
                <img
                  src={compare_quote}
                  alt="Cotizas tus autos"
                  className={styles["widget-container-image"]}
                />
                <p className={styles["widget-container-subtitle"]}>{`Cotiza tus autos (${carSelectedQuote2?.length})`}</p>
              </div>
            </section>
          </div>
        </div>
      )}

      {loading && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          zIndex: 9999,
          pointerEvents: 'none'
        }}>
          <div style={{
            border: '6px solid #ccc',
            borderTop: '6px solid #333',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            marginBottom: '1rem'
          }} />
          Cargando...

          {/* Aquí insertamos la animación CSS */}
          <style>
            {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
          </style>
        </div>
      )}


    </BaseLayoutStore>

  );

};

export default SalfaUsados;
